<template>
  <v-app class="design-viewer-app">
    <div v-if="variant" class="design-viewer">
      <div class="design-viewer__bar">
        <router-link to="/designs" class="design-viewer__back">← All designs</router-link>
        <span class="design-viewer__label">{{ variant.name }}</span>
        <div class="design-viewer__nav">
          <router-link v-if="prevVariant" :to="`/designs/${prevVariant.id}`">← {{ prevVariant.name }}</router-link>
          <router-link v-if="nextVariant" :to="`/designs/${nextVariant.id}`">{{ nextVariant.name }} →</router-link>
        </div>
      </div>
      <component :is="activeComponent" />
    </div>
    <v-main v-else class="design-viewer__missing">
      <h1>Design not found</h1>
      <router-link to="/designs">Back to gallery</router-link>
    </v-main>
  </v-app>
</template>

<script>
import { DESIGN_VARIANTS } from '@/components/front_page/designs/shared'
import DesignTauri from '@/components/front_page/designs/DesignTauri.vue'
import DesignDropbox from '@/components/front_page/designs/DesignDropbox.vue'
import DesignBento from '@/components/front_page/designs/DesignBento.vue'
import DesignNature from '@/components/front_page/designs/DesignNature.vue'
import DesignTerminal from '@/components/front_page/designs/DesignTerminal.vue'
import DesignSplit from '@/components/front_page/designs/DesignSplit.vue'
import DesignGlass from '@/components/front_page/designs/DesignGlass.vue'
import DesignSwiss from '@/components/front_page/designs/DesignSwiss.vue'
import DesignDashboard from '@/components/front_page/designs/DesignDashboard.vue'
import DesignPipeline from '@/components/front_page/designs/DesignPipeline.vue'
import TrustedDeviceMixin from '@/mixins/TrustedDeviceMixin.vue'

const COMPONENT_MAP = {
  DesignTauri,
  DesignDropbox,
  DesignBento,
  DesignNature,
  DesignTerminal,
  DesignSplit,
  DesignGlass,
  DesignSwiss,
  DesignDashboard,
  DesignPipeline,
}

export default {
  name: 'FrontPageDesignViewer',
  components: COMPONENT_MAP,
  mixins: [TrustedDeviceMixin],
  props: {
    variantId: {
      type: String,
      required: true,
    },
  },
  computed: {
    variantIndex() {
      return DESIGN_VARIANTS.findIndex((v) => v.id === this.variantId)
    },
    variant() {
      if (this.variantIndex === -1) {
        return null
      }
      return DESIGN_VARIANTS[this.variantIndex]
    },
    activeComponent() {
      if (!this.variant) {
        return null
      }
      return COMPONENT_MAP[this.variant.component]
    },
    prevVariant() {
      if (this.variantIndex <= 0) {
        return null
      }
      return DESIGN_VARIANTS[this.variantIndex - 1]
    },
    nextVariant() {
      if (this.variantIndex === -1 || this.variantIndex >= DESIGN_VARIANTS.length - 1) {
        return null
      }
      return DESIGN_VARIANTS[this.variantIndex + 1]
    },
  },
  async mounted() {
    await this.checkTrustedDevice()
  },
}
</script>

<style scoped>
.design-viewer-app {
  background: transparent;
}

.design-viewer__bar {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.95);
  border-bottom: 1px solid #e0e0e0;
  backdrop-filter: blur(8px);
  font-family: system-ui, sans-serif;
  font-size: 0.85rem;
}

.design-viewer__back {
  color: #0677b9;
  text-decoration: none;
  white-space: nowrap;
}

.design-viewer__label {
  font-weight: 700;
  color: #333;
}

.design-viewer__nav {
  margin-left: auto;
  display: flex;
  gap: 16px;
}

.design-viewer__nav a {
  color: #666;
  text-decoration: none;
}

.design-viewer__nav a:hover {
  color: #0677b9;
}

.design-viewer__missing {
  text-align: center;
  padding: 80px 24px;
}

.design-viewer__missing a {
  color: #0677b9;
}
</style>
